<template>
  <div>
    <div v-if="Lib.checkPower('beauty-3-tcxshkgk',2)">
      <!-- <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="expireTimeOption" @change="onChangeTime">></el-date-picker> -->
      <date-picker @selectDate="onChangeTime" />
      <h2>套餐销售排行（前五名）</h2>
      <div v-show="personInfo.allPackageSaleCount > 0 || personInfo.allPackageSaleCount > 0" class="sunspot">
        <div v-show="personInfo && personInfo.allPackageSaleCount > 0" class="MaBor">
          <div id="Data_C" class="Data"></div>
          <p>套餐销售</p>
        </div>
        <div v-show="personInfo && personInfo.allPackageSaleCount > 0" class="MaBor">
          <div id="Data_S" class="Data"></div>
          <p>
            套餐销售占比
            <el-tooltip class="item" effect="light" :content="'单个套餐销售数量÷全部套餐销售数量×100%'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </p>
        </div>
      </div>
      <gt-noneData v-show="!personInfo|| personInfo.allPackageSaleCount == 0" :title="'暂无套餐销售数据'"></gt-noneData>
      <h2>套餐划扣排行（前五名）</h2>
      <div v-show="personInfo.allPackageDeductCount > 0 || personInfo.allPackageDeductCount > 0" class="sunspot">
        <div v-show="personInfo.allPackageDeductCount > 0" class="MaBor">
          <div id="Data_X" class="Data"></div>
          <p>套餐划扣</p>
        </div>
        <div v-show="personInfo.allPackageDeductCount > 0" class="MaBor">
          <div id="Data_T" class="Data"></div>
          <p>
            套餐划扣占比
            <el-tooltip class="item" effect="light" :content="'单个套餐划扣总次数÷全部套餐划扣总次数×100%'" placement="right">
              <i class="el-icon-warning" style="color:#D2D2D2;font-size:13px;"></i>
            </el-tooltip>
          </p>
        </div>
      </div>
      <gt-noneData v-if="!personInfo || personInfo.allPackageDeductCount == 0" :title="'暂无套餐划扣数据'"></gt-noneData>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>
<script>
// import dayjs from 'dayjs';
import * as echarts from 'echarts';
// import echarts from 'echarts';
import { staffC } from '../echarts/dataC';
import { staffS } from '../echarts/dataS';
import { staffT } from '../echarts/dataT';
import { staffX } from '../echarts/dataX';
import api from '../api/index';
// import { getVipCardSaleAndDeductMsg, } from '../api';
// (5.2)套餐概况}
export default {
  data() {
    return {
      // time: [
      //   dayjs()
      //     .subtract(30, 'day')
      //     .format('YYYY-MM-DD'),
      //   dayjs().format('YYYY-MM-DD')
      // ],
      // expireTimeOption: {
      //   disabledDate(date) {
      //     return date.getTime() > Date.now();
      //   }
      // },
      personInfo: {},
    };
  },
  activated() {
    // this.getList();
  },
  methods: {
    // 修改日期
    onChangeTime(e) {
      this.getList(e);
    },
    // 获取套餐概括
    getList(e) {
      const data = {
        startTime: e.beginTime,
        endTime: e.endTime,
        dateType: e.dateType,
        mainId: sessionStorage.getItem('mainId'),
      };
      api.getVipCardSaleAndDeductMsg(data).then((res) => {
        this.personInfo = res.data ? res.data : '';
        console.log(this.personInfo);
        if (this.personInfo) {
          if (res.data.vipCardSaleList.length > 0) {
            for (let i = 0; i < res.data.vipCardSaleList.length; i++) {
              res.data.vipCardSaleList[i].num = 100;
            }
          }
          if (res.data.vipCardDeductList.length > 0) {
            for (let i = 0; i < res.data.vipCardDeductList.length; i++) {
              res.data.vipCardDeductList[i].num = 100;
            }
          }
          this.initDataC(res.data.vipCardSaleList);
          this.initDataS(res.data.vipCardSaleList, res.data.allPackageSaleCount);
          this.initDataX(res.data.vipCardDeductList);
          this.initDataT(res.data.vipCardDeductList, res.data.allPackageDeductCount);
        }
      });
    },
    // 创建套餐销售柱线图
    initDataC(data) {
      // 基于准备好的dom，初始化echarts实例
      const myChartC = echarts.init(document.getElementById('Data_C'));
      // 指定图表的配置项和数据
      // 使用刚指定的配置项和数据显示图表。
      const optionC = staffC(data);
      myChartC.setOption(optionC);
    },
    // 创建套餐销售占比柱线图
    initDataS(data, Count) {
      // 基于准备好的dom，初始化echarts实例
      const myChartS = echarts.init(document.getElementById('Data_S'));
      // 指定图表的配置项和数据
      // 使用刚指定的配置项和数据显示图表。
      const optionS = staffS(data, Count);
      myChartS.setOption(optionS);
    },
    // 创建套餐划扣柱线图
    initDataX(data) {
      // 基于准备好的dom，初始化echarts实例
      const myChartX = echarts.init(document.getElementById('Data_X'));
      // 指定图表的配置项和数据
      // 使用刚指定的配置项和数据显示图表。
      const optionX = staffX(data);
      myChartX.setOption(optionX);
    },
    // 创建套餐划扣占比柱线图
    initDataT(data, Count) {
      // 基于准备好的dom，初始化echarts实例
      const myChartT = echarts.init(document.getElementById('Data_T'));
      // 指定图表的配置项和数据
      // 使用刚指定的配置项和数据显示图表。
      const optionT = staffT(data, Count);
      myChartT.setOption(optionT);
    },

  },
};
</script>
<style scoped>
h2 {
    font-size: 15px;
    margin: 20px 0;
    font-weight: bold;
}
.sunspot {
    border: 1px solid #ebeef5;
}
.MaBor {
    text-align: center;
    width: 600px;
    margin-right: 120px;
    display: inline-block;
}
.MaBor p {
    color: #333;
    font-size: 13px;
    margin: 20px 0 40px;
}
.Data {
    width: 700px;
    height: 300px;
    padding-bottom: env(safe-area-inset-bottom);
    margin-top: 20px;
}
</style>
